import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider } from '@mui/material';
import Preloader from 'src/components/Preloader';
import ReviewData from './ReviewData';
import useStyles from '../styles';

const FinalStep = ({ data, handleSubmit, handleBack, loading }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();


  const content = useMemo(() => {
    return !loading ? <ReviewData values={data} /> : <Preloader />;
  }, [loading, data]);

  const handleOtherSubmit = e => {
    e.preventDefault();
    handleSubmit(data);
  };

  return (
    <FadeIn>
      <form onSubmit={handleOtherSubmit}>
        <Divider light />
        {content}

        <Box
          className={classes.tableBox}
          display="flex"
          justifyContent="space-between"
        >
          <Button
            className={classes.buttons}
            onClick={handleBack}
            color="primary"
            variant="outlined"
            disabled={loading}
          >
            {t('COMMON.BACK')}
          </Button>
          <Button
            className={clsx(classes.buttons, classes.buttonMain)}
            type="submit"
            color="primary"
            variant="outlined"
            disabled={loading}
          >
            {t('COMMON.ASSIGN')}
          </Button>
        </Box>
      </form>
    </FadeIn>
  );
};
FinalStep.propTypes = {
  data: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default FinalStep;
